export default __webpack_public_path__ + "static/media/BuickFavicon.5e84c985.ico";